import { render, staticRenderFns } from "./TopButtonsComponent.vue?vue&type=template&id=06069692&scoped=true"
import script from "./TopButtonsComponent.vue?vue&type=script&lang=js"
export * from "./TopButtonsComponent.vue?vue&type=script&lang=js"
import style0 from "./TopButtonsComponent.vue?vue&type=style&index=0&id=06069692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06069692",
  null
  
)

export default component.exports